/** src/presentation/components/common/DataTable/DataTable.tsx */

import styles from './DataTable.module.css';

export interface DataTableColumn<T> {
  key: keyof T | string;
  header: string;
  render?: (item: T) => React.ReactNode;
}

interface DataTableProps<T> {
  columns: DataTableColumn<T>[];
  data: T[];
  emptyMessage?: string;
  maxHeight?: string;
  page?: number;
  hasPrevious?: boolean;
  hasNext?: boolean;
  onPrevious?: () => void;
  onNext?: () => void;
  onRowClick?: (item: T) => void;
}

export function DataTable<T>({
  columns,
  data,
  emptyMessage = 'No hay datos para mostrar',
  maxHeight = '450px',
  page,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onRowClick,
}: DataTableProps<T>) {
  return (
    <div className={styles.tableWrapper} style={{ maxHeight }}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={String(column.key)}>{column.header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, rowIndex) => (
              <tr key={rowIndex} onClick={() => onRowClick?.(item)}
                className={
                  onRowClick ? styles.clickableRow : undefined
                }>
                {columns.map((column) => (
                  <td key={String(column.key)}>
                    {column.render
                      ? column.render(item)
                      : String(item[column.key as keyof T] ?? '')}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>

              <td colSpan={columns.length} className={styles.emptyCell}>
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {page !== undefined && (
        <div className={styles.pagination}>
          <button
            onClick={onPrevious}
            disabled={!hasPrevious}
          >
            ← Anterior
          </button>

          <span>Página {page}</span>

          <button
            onClick={onNext}
            disabled={!hasNext}
          >
            Siguiente →
          </button>
        </div>
      )}
    </div>
  );
}